import React from 'react';
import VerifyEmail from './VerifyEmail';

const StaffVerifyEmail: React.FC = () => {
  return <VerifyEmail accountType="staff" />;
};

export default StaffVerifyEmail;
